import { HttpClient } from '@angular/common/http';
import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  inject,
  resource,
  signal,
} from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { ContentContainer } from '../../../../core/content-container/content-container';
import { GetBlogPosts } from './services/get-blog-posts';

const BLOG_POSTS_LIMIT = 3;

@Component({
  selector: 'app-blog-posts',
  imports: [ContentContainer],
  templateUrl: './blog-posts.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogPosts {
  private getBlogPosts = inject(GetBlogPosts);

  blogPostsLimit = signal(Array.from({ length: BLOG_POSTS_LIMIT }));

  blogPosts = signal([]);

  constructor() {
    afterNextRender(() => {
      this.getBlogPosts.get(BLOG_POSTS_LIMIT).subscribe((blogPosts) => {
        this.blogPosts.set(blogPosts);
      });
    });
  }
}
